(function ($) {
    function initMarquee($root) {
        if (!$root.length || $root.data("marquee-ready")) return;

        var $viewport = $root.find(".marquee__viewport").first();
        var $track = $root.find(".marquee__track").first();
        var $group = $root.find(".marquee__group").first();

        if (!$viewport.length || !$track.length || !$group.length) return;

        $root.data("marquee-ready", true);

        var originalHtml = $group.html();
        var resizeTimer = null;

        function rebuild() {
            var viewportWidth = $viewport.outerWidth();

            $track.find(".marquee__group--clone").remove();
            $group.html(originalHtml);

            if (!viewportWidth) return;

            var guard = 0;
            while ($group.outerWidth(true) < viewportWidth * 1.25 && guard < 20) {
                $group.append(originalHtml);
                guard += 1;
            }

            $group
                .clone()
                .addClass("marquee__group--clone")
                .attr("aria-hidden", "true")
                .appendTo($track);
        }

        function scheduleRebuild() {
            window.clearTimeout(resizeTimer);
            resizeTimer = window.setTimeout(rebuild, 100);
        }

        rebuild();

        $root.find("img").on("load", scheduleRebuild);
        $(window).on("resize", scheduleRebuild);
    }

    $(window).on("elementor/frontend/init", function () {
        if (window.elementorFrontend && window.elementorFrontend.hooks) {
            window.elementorFrontend.hooks.addAction(
                "frontend/element_ready/marquee.default",
                function ($scope) {
                    var $root = $scope.find(".marquee").first();
                    if ($root.length) initMarquee($root);
                }
            );
        }
    });

    $(function () {
        $(".marquee").each(function () {
            initMarquee($(this));
        });
    });
})(jQuery);
